/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react'
import PropTypes from 'prop-types'
import Nara from '../images/nara.png'
import Tive from '../images/tive.png'
import NLine from '../images/n-line.png'
import N from '../images/nblue.png'


const Logo = ({ isCollapsed }) => {
  return (
    <div className={ isCollapsed ? 'logo-colladpsed animated-logo' : 'animated-logo'}>
      <div className='nara'>
        <img
          alt={'Logo start'}
          src={Nara}
        />
        <img
        className='logo-leg'
          alt={'N'}
          src={N}
        />
      </div>

      <div className="n-line-cont">
        <div className='n-line'>
          <img
            alt={'Logo line'}
            src={NLine}
          />
        </div>
      </div>

      <div className='tive'>
      <img
        alt={'Logo end'}
        src={Tive}
        />
      </div>
    </div>)
}

Logo.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
}

export default Logo
